import { ISelected } from '../../../../core-ui/index';
import { IColumnPk } from '../../../../webapi/index';
import { ColumnFieldType } from '../../enums/index';
import { ColumnFieldTypeObject } from '../ColumnFieldTypeObject';

export class ColumnCheckboxDto extends ColumnFieldTypeObject {
  OnChangeCallback: (dataDto: IColumnPk & ISelected) => void;

  constructor(init?: Partial<ColumnCheckboxDto>) {
    super();
    this.FieldType = ColumnFieldType.Checkbox;
    Object.assign(this, init);
  }
}
